import { useCountUp } from '../../hooks/useCountUp';

interface AnimatedNumberProps {
  value: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
  duration?: number;
  className?: string;
}

export const AnimatedNumber = ({ 
  value, 
  prefix = '', 
  suffix = '', 
  decimals = 0,
  duration = 2000,
  className = ''
}: AnimatedNumberProps) => {
  const animatedValue = useCountUp({ 
    end: value, 
    duration,
    decimals 
  });

  const formatNumber = (num: number) => {
    if (decimals > 0) {
      return num.toFixed(decimals);
    }
    return Math.round(num).toLocaleString();
  };

  return (
    <span className={className}>
      {prefix}{formatNumber(animatedValue)}{suffix}
    </span>
  );
};